<div class="display-flex flex-column">
  <h2 mat-dialog-title class="modal-header subtitle display-flex justify-content-space-between align-items-center">
    {{ data.showDoNotShowAgain ? 'Save template?' : 'Save template' }}
  </h2>
  <mat-dialog-content
    class="mat-dialog-content display-flex flex-column align-items-start grid-gap-12"
    [formGroup]="form"
  >
    <div *ngIf="data.showDoNotShowAgain">
      You have changed this template. If you do NOT save, your changes will affect only this cell. If you DO save it
      will affect all unstarted inspections in this column.
    </div>
    <app-input
      #templateInput
      [labelCss]="'nowrap pre-label'"
      [containerCss]="'display-flex align-items-center grid-gap-4'"
      [attrPlaceholder]="'Template name'"
      formControlName="name"
      [attrLabel]="'Name'"
    ></app-input>

    <div class="display-flex justify-content-space-between align-items-center align-self-stretch">
      <button
        class="modal-button"
        mat-stroked-button
        [color]="'warn'"
        (click)="cancel()"
        *ngIf="data.showDoNotShowAgain; else modalCancel"
      >
        Don't save
      </button>
      <ng-template #modalCancel>
        <button class="modal-button" mat-stroked-button [color]="'warn'" (click)="cancel()">Cancel</button>
      </ng-template>

      <button
        class="modal-button"
        mat-raised-button
        [color]="'primary'"
        (click)="save()"
        *ngIf="data.showDoNotShowAgain; else modalSave"
      >
        Save template
      </button>
      <ng-template #modalSave>
        <button class="modal-button" mat-raised-button [color]="'primary'" (click)="save()">Save</button>
      </ng-template>
    </div>

    <mat-checkbox
      class="mat-checkbox"
      *ngIf="data.showDoNotShowAgain"
      color="primary"
      [(ngModel)]="doNotShowAgain"
      [ngModelOptions]="{ standalone: true }"
      >Don't show for this column again</mat-checkbox
    >
  </mat-dialog-content>
</div>
